module.exports = __webpack_public_path__ + "static/media/vimeo.b788e5ce.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Container/components/Footer/img/vimeo.svg
// module id = 145
// module chunks = 0